import { gql } from '@apollo/client'

export const GET_USER_GROUP_ROLES = gql`
  query {
    getUserGroupRoles {
      code
    }
  }
`
